import React, { useContext } from "react";
import RbdGenericList from "../Parque/RbdGenericList";
import PageBody from "../GeneralComponents/PageBody";
import GeneralContext from "../GeneralContext/GeneralContext";

import {
  ROL_ADMIN,
  ROL_CON_MINEDUC,
  ROL_MINEDUC_ADMIN,
  ROL_OP_ADMIN,
} from "../../Constants/Constants";

export default function ParqueList() {
  const { includeRol } = useContext(GeneralContext);

  const isOpAdmin = includeRol([ROL_OP_ADMIN]);

  return (
    <PageBody>
      {isOpAdmin ? (
        <RbdGenericList
          pageTitleOverride="Lista RBD"
          columnOrder={[
            "checkbox",
            "rbd",
            "concurso",
            "nombre_ee",
            "representante",
            "jornada",
            "estado",
            "estado_pago",
            "detalle",
          ]}
          filtersConfig={[
            { item: "concurso", name: "Convocatoria" },
            { item: "nombre_ee", name: "Nombre Establecimiento" },
            { item: "representante", name: "Representante" },
            { item: "jornada", name: "Ventana horaria" },
            { item: "estado_pago", name: "Estado pago" },
            { item: "estado", name: "Estado servicio" },
          ]}
        />
      ) : includeRol([ROL_MINEDUC_ADMIN]) ?
      (
        
        <RbdGenericList
          opview={true}
          pageTitleOverride="Lista RBD"
          columnOrder={[
            "checkbox",
            "rbd",
            "concurso",
            "nombre_ee",
            "representante",
            "jornada",
            "estado",
            "estado_pago",
            "detalle",
          ]}
          filtersConfig={[
            { item: "nombre_operador", name: "Operador" },
            { item: "concurso", name: "Convocatoria" },
            { item: "nombre_ee", name: "Nombre Establecimiento" },
            { item: "representante", name: "Representante" },
            { item: "jornada", name: "Ventana horaria" },
            { item: "estado_pago", name: "Estado pago" },
            { item: "estado", name: "Estado servicio" },
          ]}
        />
      ) : (
        
        <RbdGenericList
          opview={true}
          pageTitleOverride="Lista RBD"
          columnOrder={[
            "checkbox",
            "rbd",
            "nombre_operador",
            "concurso",
            "nombre_ee",
            "jornada",
            "estado",
            "estado_pago",
            "detalle",
          ]}
          filtersConfig={[
            { item: "nombre_operador", name: "Operador" },
            { item: "concurso", name: "Convocatoria" },
            { item: "nombre_ee", name: "Nombre Establecimiento" },
            { item: "jornada", name: "Ventana horaria" },
            { item: "estado_pago", name: "Estado pago" },
            { item: "estado", name: "Estado servicio" },
          ]}
        />
      )}
    </PageBody>
  );
}
